
import { Component, Vue } from 'vue-property-decorator';
import actions from '@/shared/actions';
// import { IProject } from "@/types/interface";
import getExtraUrl from '@/utils/extraUrl';
import { apiGetPcUserPositionList } from '@/api/shadow';
import type { PositionItem } from '@/types/shadow';

export interface IProject {
  addTime: number;
  approvers: string;
  icon: string;
  projectId: number;
  projectName: string;
  projectTag: string;
  showType: number;
  url?: string;
}

interface SubProjectModal {
  projectId: number;
  projectName: string;
  projectTag: string;
  projectDesc: string;
  icon: string;
  url: string;
  showType: number;
  key?: string;
  title?: string;
  path?: string;
  [propName: string]: any;
}

interface ProjectItemModal {
  categirtId: number;
  name: String;
  data: Array<SubProjectModal>;
}

interface ProjectInfo {
  roleName?: string;
  projects?: ProjectItemModal[];
  userInfo?: UserInfo;
}

interface UserInfo {
  account: string;
  email: string;
  userName: string;
  [key: string]: any;
}

@Component({})
export default class Home extends Vue {
  now: number = Date.now();
  projects: SubProjectModal[] = [];

  mounted() {
    actions.onGlobalStateChange((state: ProjectInfo): void => {
      if (!state.projects) {
        return;
      }
      const projects: Array<ProjectItemModal> = state!.projects || [];
      const knownProjectIds = [88, 38, 29, 57];
      const knowProjects = new Array(4);
      const otherProjects: SubProjectModal[] = [];
      projects.forEach((item: ProjectItemModal) => {
        item.data.forEach((subItem: SubProjectModal) => {
          if (knownProjectIds.includes(subItem.projectId)) {
            const index = knownProjectIds.indexOf(subItem.projectId);
            knowProjects[index] = subItem;
          } else {
            otherProjects.push(subItem);
          }
        });
      });

      this.projects = [...knowProjects.filter(v => !!v), ...otherProjects].sort((a, b) => {
        const ao = Number((a as any)?.orderValue ?? 0);
        const bo = Number((b as any)?.orderValue ?? 0);
        // orderValue 降序（大的排前面）；非数字按 0 处理
        return (Number.isFinite(bo) ? bo : 0) - (Number.isFinite(ao) ? ao : 0);
      });

      // // 获取到 projects 后，判断是否需要跳转
      // this.checkAndRedirect();

    }, true);
  }

  // async checkAndRedirect() {
  //   try {
  //     const res = await apiGetPcUserPositionList();
  //     if (res && res.code === 0 && res.data && res.data.positionList && res.data.clientPositionType) {
  //       // 检查 positionList 中的 positionType 是否只包含 clientPositionType 中的内容
  //       const clientPositionTypes = res.data.clientPositionType;
  //       const allPositionTypesInClient = res.data.positionList.every(
  //         (item: PositionItem) => clientPositionTypes.includes(item.positionType)
  //       );
  //       // 判断 projects 中的 projectTag 是否包含 retailrevolution-partner
  //       const hasPartnerProject = this.projects.some(
  //         (project: SubProjectModal) => project.projectTag && project.projectTag.includes('retailrevolution-partner')
  //       );
  //       if (allPositionTypesInClient && hasPartnerProject) {
  //         // 如果所有 positionType 都在 clientPositionType 中，并且 projects 中包含 retailrevolution-partner，跳转到指定路由
  //         this.$router.push('/main-retailrevolution-partner');
  //         return;
  //       }
  //     }
  //   } catch (error) {
  //     console.error('获取职位信息失败:', error);
  //     // 接口失败时继续停留在当前页面
  //   }
  // }

  gotoSubApp(projectTag: string) {
    const activeRule = `/main-${projectTag}`;
    if (getExtraUrl(activeRule)) {
      window.open(getExtraUrl(activeRule));
    } else {
      this.$router.push(`/${activeRule}`);
    }
  }

  showIcon(icon: string) {
    return icon && icon.length > 0 && icon.startsWith('http');
  }
}
